module.exports = __webpack_public_path__ + "wane.f4c09837.png";